import currency from "currency.js";

export class CurrencyUtils {
    // Configure for USD (can be configured per region)
    private static readonly config = {
        symbol: "$",
        precision: 2,
        separator: ",",
        decimal: "."
    };

    /**
     * Create a currency instance from a number
     */
    static fromNumber(value: number | undefined): currency {
        return currency(value ?? 0, this.config);
    }

    /**
     * Convert currency instance to number (for storage/API)
     */
    static toNumber(value: currency): number {
        return value.value;
    }

    /**
     * Format currency for display
     */
    static format(value: currency | number): string {
        if (typeof value === "number") {
            return currency(value, this.config).format();
        }
        return value.format();
    }

    /**
     * Round to 2 decimal places (replacement for roundDollarAmount)
     */
    static round(value: number | undefined): number {
        return currency(value ?? 0, this.config).value;
    }

    /**
     * Whole percent off for a discount's pricing factor (0.95 → 5). Rounded because 1 - 0.95 is not exactly 0.05 in floating point.
     */
    static adjustmentToPercent(adjustment: number | undefined): number {
        return Math.round((1 - (adjustment ?? 1)) * 100);
    }
}
